import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';

import { LicenseService } from './license.service';

export const licenseGuard: CanActivateFn = () => {
  // Wait for the license request itself: licensedFeatures holds non-empty defaults before it completes
  return toObservable(inject(LicenseService).loaded).pipe(
    filter((loaded) => loaded),
    take(1),
    map(() => true),
  );
};
